/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './pages/__root'
import { Route as AppRouteRouteImport } from './pages/_app/route'
import { Route as ChangePasswordRouteImport } from './pages/change-password'
import { Route as AppIndexRouteImport } from './pages/_app/index'
import { Route as AppBataillonsRouteImport } from './pages/_app/bataillons'
import { Route as AppCheckInRouteImport } from './pages/_app/check-in'
import { Route as AppGalleryRouteImport } from './pages/_app/gallery'
import { Route as AppProfileRouteImport } from './pages/_app/profile'
import { Route as AppTestimonialsRouteImport } from './pages/_app/testimonials'
import { Route as AuthForgotPasswordRouteImport } from './pages/_auth/forgot-password'
import { Route as AuthSignInRouteImport } from './pages/_auth/sign-in'
import { Route as AppResourceIndexRouteImport } from './pages/_app/$resource/index'
import { Route as AppResourceCreateRouteImport } from './pages/_app/$resource/create'
import { Route as AppScreensIndexRouteImport } from './pages/_app/screens/index'
import { Route as AppScreensCreateRouteImport } from './pages/_app/screens/create'
import { Route as AppTermVersionsIndexRouteImport } from './pages/_app/term-versions/index'
import { Route as AppTermVersionsIdRouteImport } from './pages/_app/term-versions/$id'
import { Route as AppResourceIdIndexRouteImport } from './pages/_app/$resource/$id/index'
import { Route as AppResourceIdViewRouteImport } from './pages/_app/$resource/$id/view'
import { Route as AppScreensIdIndexRouteImport } from './pages/_app/screens/$id/index'
import { Route as AppScreensIdViewRouteImport } from './pages/_app/screens/$id/view'

const AppRouteRoute = AppRouteRouteImport.update({
  id: '/_app',
  getParentRoute: () => rootRouteImport,
} as any)
const ChangePasswordRoute = ChangePasswordRouteImport.update({
  id: '/change-password',
  path: '/change-password',
  getParentRoute: () => rootRouteImport,
} as any)
const AppIndexRoute = AppIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AppRouteRoute,
} as any)
const AppBataillonsRoute = AppBataillonsRouteImport.update({
  id: '/bataillons',
  path: '/bataillons',
  getParentRoute: () => AppRouteRoute,
} as any)
const AppCheckInRoute = AppCheckInRouteImport.update({
  id: '/check-in',
  path: '/check-in',
  getParentRoute: () => AppRouteRoute,
} as any)
const AppGalleryRoute = AppGalleryRouteImport.update({
  id: '/gallery',
  path: '/gallery',
  getParentRoute: () => AppRouteRoute,
} as any)
const AppProfileRoute = AppProfileRouteImport.update({
  id: '/profile',
  path: '/profile',
  getParentRoute: () => AppRouteRoute,
} as any)
const AppTestimonialsRoute = AppTestimonialsRouteImport.update({
  id: '/testimonials',
  path: '/testimonials',
  getParentRoute: () => AppRouteRoute,
} as any)
const AuthForgotPasswordRoute = AuthForgotPasswordRouteImport.update({
  id: '/_auth/forgot-password',
  path: '/forgot-password',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthSignInRoute = AuthSignInRouteImport.update({
  id: '/_auth/sign-in',
  path: '/sign-in',
  getParentRoute: () => rootRouteImport,
} as any)
const AppResourceIndexRoute = AppResourceIndexRouteImport.update({
  id: '/$resource/',
  path: '/$resource/',
  getParentRoute: () => AppRouteRoute,
} as any)
const AppResourceCreateRoute = AppResourceCreateRouteImport.update({
  id: '/$resource/create',
  path: '/$resource/create',
  getParentRoute: () => AppRouteRoute,
} as any)
const AppScreensIndexRoute = AppScreensIndexRouteImport.update({
  id: '/screens/',
  path: '/screens/',
  getParentRoute: () => AppRouteRoute,
} as any)
const AppScreensCreateRoute = AppScreensCreateRouteImport.update({
  id: '/screens/create',
  path: '/screens/create',
  getParentRoute: () => AppRouteRoute,
} as any)
const AppTermVersionsIndexRoute = AppTermVersionsIndexRouteImport.update({
  id: '/term-versions/',
  path: '/term-versions/',
  getParentRoute: () => AppRouteRoute,
} as any)
const AppTermVersionsIdRoute = AppTermVersionsIdRouteImport.update({
  id: '/term-versions/$id',
  path: '/term-versions/$id',
  getParentRoute: () => AppRouteRoute,
} as any)
const AppResourceIdIndexRoute = AppResourceIdIndexRouteImport.update({
  id: '/$resource/$id/',
  path: '/$resource/$id/',
  getParentRoute: () => AppRouteRoute,
} as any)
const AppResourceIdViewRoute = AppResourceIdViewRouteImport.update({
  id: '/$resource/$id/view',
  path: '/$resource/$id/view',
  getParentRoute: () => AppRouteRoute,
} as any)
const AppScreensIdIndexRoute = AppScreensIdIndexRouteImport.update({
  id: '/screens/$id/',
  path: '/screens/$id/',
  getParentRoute: () => AppRouteRoute,
} as any)
const AppScreensIdViewRoute = AppScreensIdViewRouteImport.update({
  id: '/screens/$id/view',
  path: '/screens/$id/view',
  getParentRoute: () => AppRouteRoute,
} as any)

export interface FileRoutesByFullPath {
  '/': typeof AppIndexRoute
  '/change-password': typeof ChangePasswordRoute
  '/bataillons': typeof AppBataillonsRoute
  '/check-in': typeof AppCheckInRoute
  '/gallery': typeof AppGalleryRoute
  '/profile': typeof AppProfileRoute
  '/testimonials': typeof AppTestimonialsRoute
  '/forgot-password': typeof AuthForgotPasswordRoute
  '/sign-in': typeof AuthSignInRoute
  '/$resource/create': typeof AppResourceCreateRoute
  '/screens/create': typeof AppScreensCreateRoute
  '/term-versions/$id': typeof AppTermVersionsIdRoute
  '/$resource/': typeof AppResourceIndexRoute
  '/screens/': typeof AppScreensIndexRoute
  '/term-versions/': typeof AppTermVersionsIndexRoute
  '/$resource/$id/view': typeof AppResourceIdViewRoute
  '/screens/$id/view': typeof AppScreensIdViewRoute
  '/$resource/$id/': typeof AppResourceIdIndexRoute
  '/screens/$id/': typeof AppScreensIdIndexRoute
}
export interface FileRoutesByTo {
  '/change-password': typeof ChangePasswordRoute
  '/bataillons': typeof AppBataillonsRoute
  '/check-in': typeof AppCheckInRoute
  '/gallery': typeof AppGalleryRoute
  '/profile': typeof AppProfileRoute
  '/testimonials': typeof AppTestimonialsRoute
  '/forgot-password': typeof AuthForgotPasswordRoute
  '/sign-in': typeof AuthSignInRoute
  '/': typeof AppIndexRoute
  '/$resource/create': typeof AppResourceCreateRoute
  '/screens/create': typeof AppScreensCreateRoute
  '/term-versions/$id': typeof AppTermVersionsIdRoute
  '/$resource': typeof AppResourceIndexRoute
  '/screens': typeof AppScreensIndexRoute
  '/term-versions': typeof AppTermVersionsIndexRoute
  '/$resource/$id/view': typeof AppResourceIdViewRoute
  '/screens/$id/view': typeof AppScreensIdViewRoute
  '/$resource/$id': typeof AppResourceIdIndexRoute
  '/screens/$id': typeof AppScreensIdIndexRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/_app': typeof AppRouteRouteWithChildren
  '/change-password': typeof ChangePasswordRoute
  '/_app/bataillons': typeof AppBataillonsRoute
  '/_app/check-in': typeof AppCheckInRoute
  '/_app/gallery': typeof AppGalleryRoute
  '/_app/profile': typeof AppProfileRoute
  '/_app/testimonials': typeof AppTestimonialsRoute
  '/_auth/forgot-password': typeof AuthForgotPasswordRoute
  '/_auth/sign-in': typeof AuthSignInRoute
  '/_app/': typeof AppIndexRoute
  '/_app/$resource/create': typeof AppResourceCreateRoute
  '/_app/screens/create': typeof AppScreensCreateRoute
  '/_app/term-versions/$id': typeof AppTermVersionsIdRoute
  '/_app/$resource/': typeof AppResourceIndexRoute
  '/_app/screens/': typeof AppScreensIndexRoute
  '/_app/term-versions/': typeof AppTermVersionsIndexRoute
  '/_app/$resource/$id/view': typeof AppResourceIdViewRoute
  '/_app/screens/$id/view': typeof AppScreensIdViewRoute
  '/_app/$resource/$id/': typeof AppResourceIdIndexRoute
  '/_app/screens/$id/': typeof AppScreensIdIndexRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/change-password'
    | '/bataillons'
    | '/check-in'
    | '/gallery'
    | '/profile'
    | '/testimonials'
    | '/forgot-password'
    | '/sign-in'
    | '/$resource/create'
    | '/screens/create'
    | '/term-versions/$id'
    | '/$resource/'
    | '/screens/'
    | '/term-versions/'
    | '/$resource/$id/view'
    | '/screens/$id/view'
    | '/$resource/$id/'
    | '/screens/$id/'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/change-password'
    | '/bataillons'
    | '/check-in'
    | '/gallery'
    | '/profile'
    | '/testimonials'
    | '/forgot-password'
    | '/sign-in'
    | '/'
    | '/$resource/create'
    | '/screens/create'
    | '/term-versions/$id'
    | '/$resource'
    | '/screens'
    | '/term-versions'
    | '/$resource/$id/view'
    | '/screens/$id/view'
    | '/$resource/$id'
    | '/screens/$id'
  id:
    | '__root__'
    | '/_app'
    | '/change-password'
    | '/_app/bataillons'
    | '/_app/check-in'
    | '/_app/gallery'
    | '/_app/profile'
    | '/_app/testimonials'
    | '/_auth/forgot-password'
    | '/_auth/sign-in'
    | '/_app/'
    | '/_app/$resource/create'
    | '/_app/screens/create'
    | '/_app/term-versions/$id'
    | '/_app/$resource/'
    | '/_app/screens/'
    | '/_app/term-versions/'
    | '/_app/$resource/$id/view'
    | '/_app/screens/$id/view'
    | '/_app/$resource/$id/'
    | '/_app/screens/$id/'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  AppRouteRoute: typeof AppRouteRouteWithChildren
  ChangePasswordRoute: typeof ChangePasswordRoute
  AuthForgotPasswordRoute: typeof AuthForgotPasswordRoute
  AuthSignInRoute: typeof AuthSignInRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/_app': {
      id: '/_app'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof AppRouteRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/change-password': {
      id: '/change-password'
      path: '/change-password'
      fullPath: '/change-password'
      preLoaderRoute: typeof ChangePasswordRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_app/': {
      id: '/_app/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof AppIndexRouteImport
      parentRoute: typeof AppRouteRoute
    }
    '/_app/bataillons': {
      id: '/_app/bataillons'
      path: '/bataillons'
      fullPath: '/bataillons'
      preLoaderRoute: typeof AppBataillonsRouteImport
      parentRoute: typeof AppRouteRoute
    }
    '/_app/check-in': {
      id: '/_app/check-in'
      path: '/check-in'
      fullPath: '/check-in'
      preLoaderRoute: typeof AppCheckInRouteImport
      parentRoute: typeof AppRouteRoute
    }
    '/_app/gallery': {
      id: '/_app/gallery'
      path: '/gallery'
      fullPath: '/gallery'
      preLoaderRoute: typeof AppGalleryRouteImport
      parentRoute: typeof AppRouteRoute
    }
    '/_app/profile': {
      id: '/_app/profile'
      path: '/profile'
      fullPath: '/profile'
      preLoaderRoute: typeof AppProfileRouteImport
      parentRoute: typeof AppRouteRoute
    }
    '/_app/testimonials': {
      id: '/_app/testimonials'
      path: '/testimonials'
      fullPath: '/testimonials'
      preLoaderRoute: typeof AppTestimonialsRouteImport
      parentRoute: typeof AppRouteRoute
    }
    '/_auth/forgot-password': {
      id: '/_auth/forgot-password'
      path: '/forgot-password'
      fullPath: '/forgot-password'
      preLoaderRoute: typeof AuthForgotPasswordRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_auth/sign-in': {
      id: '/_auth/sign-in'
      path: '/sign-in'
      fullPath: '/sign-in'
      preLoaderRoute: typeof AuthSignInRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_app/$resource/': {
      id: '/_app/$resource/'
      path: '/$resource'
      fullPath: '/$resource/'
      preLoaderRoute: typeof AppResourceIndexRouteImport
      parentRoute: typeof AppRouteRoute
    }
    '/_app/$resource/create': {
      id: '/_app/$resource/create'
      path: '/$resource/create'
      fullPath: '/$resource/create'
      preLoaderRoute: typeof AppResourceCreateRouteImport
      parentRoute: typeof AppRouteRoute
    }
    '/_app/screens/': {
      id: '/_app/screens/'
      path: '/screens'
      fullPath: '/screens/'
      preLoaderRoute: typeof AppScreensIndexRouteImport
      parentRoute: typeof AppRouteRoute
    }
    '/_app/screens/create': {
      id: '/_app/screens/create'
      path: '/screens/create'
      fullPath: '/screens/create'
      preLoaderRoute: typeof AppScreensCreateRouteImport
      parentRoute: typeof AppRouteRoute
    }
    '/_app/term-versions/': {
      id: '/_app/term-versions/'
      path: '/term-versions'
      fullPath: '/term-versions/'
      preLoaderRoute: typeof AppTermVersionsIndexRouteImport
      parentRoute: typeof AppRouteRoute
    }
    '/_app/term-versions/$id': {
      id: '/_app/term-versions/$id'
      path: '/term-versions/$id'
      fullPath: '/term-versions/$id'
      preLoaderRoute: typeof AppTermVersionsIdRouteImport
      parentRoute: typeof AppRouteRoute
    }
    '/_app/$resource/$id/': {
      id: '/_app/$resource/$id/'
      path: '/$resource/$id'
      fullPath: '/$resource/$id/'
      preLoaderRoute: typeof AppResourceIdIndexRouteImport
      parentRoute: typeof AppRouteRoute
    }
    '/_app/$resource/$id/view': {
      id: '/_app/$resource/$id/view'
      path: '/$resource/$id/view'
      fullPath: '/$resource/$id/view'
      preLoaderRoute: typeof AppResourceIdViewRouteImport
      parentRoute: typeof AppRouteRoute
    }
    '/_app/screens/$id/': {
      id: '/_app/screens/$id/'
      path: '/screens/$id'
      fullPath: '/screens/$id/'
      preLoaderRoute: typeof AppScreensIdIndexRouteImport
      parentRoute: typeof AppRouteRoute
    }
    '/_app/screens/$id/view': {
      id: '/_app/screens/$id/view'
      path: '/screens/$id/view'
      fullPath: '/screens/$id/view'
      preLoaderRoute: typeof AppScreensIdViewRouteImport
      parentRoute: typeof AppRouteRoute
    }
  }
}

interface AppRouteRouteChildren {
  AppBataillonsRoute: typeof AppBataillonsRoute
  AppCheckInRoute: typeof AppCheckInRoute
  AppGalleryRoute: typeof AppGalleryRoute
  AppProfileRoute: typeof AppProfileRoute
  AppTestimonialsRoute: typeof AppTestimonialsRoute
  AppIndexRoute: typeof AppIndexRoute
  AppResourceCreateRoute: typeof AppResourceCreateRoute
  AppScreensCreateRoute: typeof AppScreensCreateRoute
  AppTermVersionsIdRoute: typeof AppTermVersionsIdRoute
  AppResourceIndexRoute: typeof AppResourceIndexRoute
  AppScreensIndexRoute: typeof AppScreensIndexRoute
  AppTermVersionsIndexRoute: typeof AppTermVersionsIndexRoute
  AppResourceIdViewRoute: typeof AppResourceIdViewRoute
  AppScreensIdViewRoute: typeof AppScreensIdViewRoute
  AppResourceIdIndexRoute: typeof AppResourceIdIndexRoute
  AppScreensIdIndexRoute: typeof AppScreensIdIndexRoute
}

const AppRouteRouteChildren: AppRouteRouteChildren = {
  AppBataillonsRoute: AppBataillonsRoute,
  AppCheckInRoute: AppCheckInRoute,
  AppGalleryRoute: AppGalleryRoute,
  AppProfileRoute: AppProfileRoute,
  AppTestimonialsRoute: AppTestimonialsRoute,
  AppIndexRoute: AppIndexRoute,
  AppResourceCreateRoute: AppResourceCreateRoute,
  AppScreensCreateRoute: AppScreensCreateRoute,
  AppTermVersionsIdRoute: AppTermVersionsIdRoute,
  AppResourceIndexRoute: AppResourceIndexRoute,
  AppScreensIndexRoute: AppScreensIndexRoute,
  AppTermVersionsIndexRoute: AppTermVersionsIndexRoute,
  AppResourceIdViewRoute: AppResourceIdViewRoute,
  AppScreensIdViewRoute: AppScreensIdViewRoute,
  AppResourceIdIndexRoute: AppResourceIdIndexRoute,
  AppScreensIdIndexRoute: AppScreensIdIndexRoute,
}

const AppRouteRouteWithChildren = AppRouteRoute._addFileChildren(
  AppRouteRouteChildren,
)

const rootRouteChildren: RootRouteChildren = {
  AppRouteRoute: AppRouteRouteWithChildren,
  ChangePasswordRoute: ChangePasswordRoute,
  AuthForgotPasswordRoute: AuthForgotPasswordRoute,
  AuthSignInRoute: AuthSignInRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
